import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { updateProfile } from "../../actions/customer";
import { showErrorSnackbar, showSuccessSnackbar } from "../../actions/snackbar";
import {
  authKey_local_storage_key,
  userInfo_local_storage_key,
} from "../../helpers/common";
import useStyles from "./styles";
import { useNavigate } from "react-router-dom";
import MetaTags from "../Common/MetaTags";
import AccountWrapper from "../Account/AccountWrapper";

export default function Profile() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const customer = useSelector((state) => state.customers.profile);
  const token = localStorage.getItem(authKey_local_storage_key);
  const classes = useStyles();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const { name, additional_mobile_number, mobile_number, pin_code, email } =
    useSelector((state) => state.customers.profile);

  const [profile, setProfile] = useState({
    name: name || "",
    email: email || "",
    pin_code: pin_code || "",
    mobile_number: mobile_number || "",
    additional_mobile_number: additional_mobile_number || "",
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();

    if (!profile.name) {
      setErrors({ name: "Name is required" });
      return;
    }

    if (!profile.mobile_number) {
      setErrors({ mobile_number: "Mobile number is required" });
      return;
    }

    if (!(profile?.mobile_number?.match('[0-9]{10}')) || profile?.mobile_number?.length !== 10) {
      setErrors({ mobile_number: "Please provide valid mobile number" });
      return;
    }

    setLoading(true);

    return dispatch(updateProfile({ ...profile, id: customer.id })).then(
      (res) => {
        setLoading(false);
        if (res.status === 200) {
          dispatch(showSuccessSnackbar("Profile Updated successfully !"));
          const customer = res.data;
          localStorage.setItem(
            userInfo_local_storage_key,
            JSON.stringify({ customer, token })
          );
          navigate("/profile");
        } else
          dispatch(showErrorSnackbar("Sorry! Profile cannot be updated !"));
      }
    );
  };

  const onValueChange = (event) => {
    setProfile({ ...profile, [event.target.name]: event.target.value });
  };

  return (
    <AccountWrapper title="Update Profile">
      <section className={classes.profileSec} style={{ paddingTop: '0' }}>
        <MetaTags
          title="Update Profile"
          description=""
          keywords=""
        ></MetaTags>

        <div className={classes.updateContainer}>
          <div className={classes.updateCard}>
            <form className={classes.updateForm} onSubmit={onSubmit}>
              <div className={classes.formRow}>
                <div className={classes.formGroup}>
                  <TextField
                    className={classes.inputField}
                    fullWidth
                    value={profile.name}
                    variant="outlined"
                    name="name"
                    onChange={onValueChange}
                    label="Full Name *"
                    error={errors.name ? true : false}
                    helperText={errors.name}
                    InputProps={{
                      startAdornment: <i className="fa fa-user" style={{ marginRight: '10px', color: '#666' }}></i>
                    }}
                  />
                </div>

                <div className={classes.formGroup}>
                  <TextField
                    className={classes.inputField}
                    fullWidth
                    value={profile.mobile_number}
                    variant="outlined"
                    type="number"
                    name="mobile_number"
                    label="Mobile Number *"
                    helperText={errors.mobile_number}
                    error={errors.mobile_number ? true : false}
                    onChange={onValueChange}
                    InputProps={{
                      startAdornment: <i className="fa fa-phone" style={{ marginRight: '10px', color: '#666' }}></i>
                    }}
                  />
                </div>
              </div>

              <div className={classes.formRow}>
                <div className={classes.formGroup}>
                  <TextField
                    className={classes.inputField}
                    fullWidth
                    variant="outlined"
                    type="email"
                    name="email"
                    label="Email Address"
                    value={profile.email}
                    onChange={onValueChange}
                    InputProps={{
                      startAdornment: <i className="fa fa-envelope" style={{ marginRight: '10px', color: '#666' }}></i>
                    }}
                  />
                </div>

                <div className={classes.formGroup}>
                  <TextField
                    className={classes.inputField}
                    fullWidth
                    value={profile.additional_mobile_number}
                    variant="outlined"
                    type="number"
                    name="additional_mobile_number"
                    label="Alternate Mobile"
                    onChange={onValueChange}
                    InputProps={{
                      startAdornment: <i className="fa fa-mobile" style={{ marginRight: '10px', color: '#666' }}></i>
                    }}
                  />
                </div>
              </div>

              <div className={classes.formActions}>
                <button 
                  type="button" 
                  className={classes.cancelButton}
                  onClick={() => navigate("/profile")}
                >
                  <i className="fa fa-times"></i>
                  Cancel
                </button>
                <button className={classes.submitButton} type="submit">
                  {loading ? "Updating..." : "Update Profile"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </AccountWrapper>
  );
}
